class _LoadScreen {
  show() {
    $('#loadScreen').show();
    $('#loadingIndicator').show();
    this.setProgress(0);
  }

  hide() {
    $('#loadScreen').hide();
  }

  setMessage(message: string) {
    $('#loadingText').text(message);
  }

  setProgress(percent: number) {
    const clamped = Math.max(0, Math.min(100, percent));
    $('#progressBar').css('width', clamped + '%');
    $('#progressText').text(Math.round(clamped) + '%');
  }

  showIndicator() {
    $('#loadingIndicator').show();
  }

  hideIndicator() {
    $('#loadingIndicator').hide();
  }
}

export const LoadScreen = new _LoadScreen();
